module.exports = __webpack_public_path__ + "img/move22.b8c21d0c.jpg";